<template>
  <div id="contenedor-nube" class="contenedor-nube">
    <div class="nube">
      <img
        v-if="(seleccionade == 'general') & (windowWidth > 769)"
        src="../assets/imgs/nube_gral.png"
        class="wordcloud animate"
      />
      <img
        v-if="(seleccionade == 'general') & (windowWidth <= 769)"
        src="../assets/imgs/movil_nube_gral.png"
        class="wordcloud animate"
      />
      <img
        v-if="(seleccionade == 'claudia') & (windowWidth > 769)"
        src="../assets/imgs/nube_claudia.png"
        class="wordcloud animate"
      />
      <img
        v-if="(seleccionade == 'claudia') & (windowWidth <= 769)"
        src="../assets/imgs/movil_nube_claudia.png"
        class="wordcloud animate"
      />
      <img
        v-if="(seleccionade == 'xochitl') & (windowWidth > 769)"
        src="../assets/imgs/nube_xochitl.png"
        class="wordcloud animate"
      />
      <img
        v-if="(seleccionade == 'xochitl') & (windowWidth <= 769)"
        src="../assets/imgs/movil_nube_xochitl.png"
        class="wordcloud animate"
      />
      <img
        v-if="(seleccionade == 'maynez') & (windowWidth > 769)"
        src="../assets/imgs/nube_maynez.png"
        class="wordcloud animate"
      />
      <img
        v-if="(seleccionade == 'maynez') & (windowWidth <= 769)"
        src="../assets/imgs/movil_nube_maynez.png"
        class="wordcloud animate"
      />
    </div>
    <div class="color-code">
      <div class="categoria" v-for="(tema, index) in temas" :key="index">
        <div
          class="color-rect"
          :style="{ 'background-color': tema_dict[tema.toLowerCase()] }"
        ></div>
        {{ tema }}
      </div>
    </div>
    <div class="derechos">
      <p class="copyrights">
        Creado con d3-cloud.<br />
        Copyright &#169; 2013, Jason Davies. All rights reserved.<br />
      </p>
    </div>
  </div>
</template>
<script setup>
import { onMounted, onUnmounted, ref, toRefs } from "vue";

const tema_dict = ref({
  "crecimiento económico, inflación y empleo": "#8E296F" /*PURPURA */,
  "infraestructura y desarrollo": "#125B8C" /*Azul oscuro*/,
  "pobreza y desigualdad": "#6C6C6C" /*GRIS */,
  "cambio climático y desarrollo sustentable": "#8B821E" /* VERDE MILITAR*/,
  /*"cambio climático": "#E32642" ROJO */
  /*"desarrollo sustentable": "#E62888" Rosa */
});
const temas = ref([
  "Crecimiento económico, inflación y empleo",
  "Infraestructura y desarrollo",
  "Pobreza y desigualdad",
  "Cambio climático y desarrollo sustentable",
  /*   "Cambio climático",
  "Desarrollo sustentable", */
]);

const contenedor_nube = ref();
const windowWidth = ref();
// eslint-disable-next-line
const props = defineProps({
  seleccionade: {
    type: String,
    default: String,
  },
});
const { seleccionade } = toRefs(props);

onMounted(() => {
  windowWidth.value = window.innerWidth;
  contenedor_nube.value = document.getElementById("contenedor-nube");
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});

function reescalanding() {
  windowWidth.value = window.innerWidth;
}
</script>
<style scoped>
.wordcloud {
  width: 100%;
}

.derechos {
  margin-top: 20px;
}
.copyrights {
  text-align: right;
  font-size: 9px;
  color: #666;
}
.contenedor-nube {
  margin-bottom: 35px;
}

.color-code {
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
}
.categoria {
  display: flex;
  /*width: 20%; */
  padding: 5px;
  margin: 5px;
}
.color-rect {
  display: inline;
  padding: 3px;
  height: 12px;
  width: 12px;
  margin: 2px;
}

.animate {
  animation-duration: 0.5s;
  animation-name: animate-fade;
  animation-delay: 0.5s;
  animation-fill-mode: backwards;
}

@keyframes animate-fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 769px) {
  .categoria {
    width: 100%;
    margin: 2px;
  }
  .color-code {
    margin-left: 0px;
    margin-right: 5px;
  }
}
</style>
